class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// Suchanfrage vor dem Submit trennzeichen-unabhängig normalisieren (normalizeCodeQuery,
// definiert in global.js): "asn55.25"/"as n 55"/"AS-N55.25" -> ein kollabierter Code-Token,
// der per Präfix den Keyword-Tag ("ASN5525") des Produkts trifft. Danach wie bisher:
// Einzelwort-Term OHNE Leerzeichen bekommt '*' angehängt ("asn" -> "asn*"), damit die
// Ergebnisseite Präfix-Treffer liefert (Shopify expandiert kurze Stubs sonst nicht).
// Mehrwort-Terme (auch umsortierte Code+Wort-Terme) verlassen sich auf options[prefix]=last.
// Beschreibende Anfragen ohne Ziffern kommen unverändert durch -> keine Regression.
// Läuft in der Bubble-Phase nach der Predictive-Logik und respektiert deren preventDefault
// (z. B. wenn ein Vorschlag ausgewählt ist -> dann kein Form-Submit).
document.addEventListener('submit', (event) => {
  if (event.defaultPrevented) return;
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  const raw = input.value.trim();
  const term = normalizeCodeQuery(raw);
  // Vollständige Artikelnummer: KEIN '*' — mit Stern liefert Shopify 15–24+ Treffer statt
  // genau einen (isFullSkuQuery in global.js, Aufgabe #67).
  if (term && !/\s/.test(term) && !term.endsWith('*') && !isFullSkuQuery(term)) {
    input.value = term + '*';
  } else {
    input.value = term;
  }
});
